import { Box, Container, Text } from '@chakra-ui/react';
import { createFileRoute } from '@tanstack/react-router';
import { useAuth } from 'react-oidc-context';

export const Route = createFileRoute('/_layout/$slug/settings')({
  component: Settings,
});

function Settings() {
  const auth = useAuth();

  return (
    <Container maxW="full">
      <Box pt={12} m={4}>
        <Text fontSize="2xl">
          Hi, {`${auth.user?.profile?.family_name}${auth.user?.profile?.name}` || auth.user?.profile?.email} 👋🏼
        </Text>
        <Text>Welcome back, nice to see you again!</Text>
        <Text>Settings</Text>
      </Box>
    </Container>
  );
}
